import { EnvObjType } from './obj';
const hashCode = (str) => {
    let hash = 0;
    let chr;
    for (let i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0; // convert to 32 bit int
    }
    return hash;
};
export const hashKey = (from) => {
    switch (from.Type()) {
        case EnvObjType.BOOLEAN:
            return from.Value ? 1 : 0;
        case EnvObjType.NUMBER:
            return from.Value;
        case EnvObjType.STRING:
            return hashCode(from.Value);
        default:
            throw new Error(`Invalid HashKey from ${from.Type()}!`);
    }
};
/* export class HashKey {
    private type: EnvObjType;
    private value: number;

    get Type() {
        return this.type;
    }
    get Value() {
        return this.value;
    }

    constructor(from: EnvObj) {
        switch (from.Type()) {
            case EnvObjType.BOOLEAN:
                this.type = from.Type();
                this.value = (from as BoolObj).Value ? 1 : 0;
                break;
            case EnvObjType.NUMBER:
                this.type = from.Type();
                this.value = (from as NumberObj).Value;
                break;
            case EnvObjType.STRING:
                this.type = from.Type();
                this.value = hashCode((from as StringObj).Value);
                break;
            default:
                throw new Error(`Invalid HashKey from ${from.Type()}!`);
        }
    }
} */
export const Hashable = (obj) => obj.Type() === EnvObjType.BOOLEAN ||
    obj.Type() === EnvObjType.NUMBER ||
    obj.Type() === EnvObjType.STRING;
export class HashObj {
    constructor(pairs = new Map()) {
        this.pairs = pairs;
    }
    get Pairs() {
        return this.pairs;
    }
    Type() {
        return EnvObjType.HASH;
    }
    Inspect() {
        const pairs = [];
        this.pairs.forEach((value) => {
            pairs.push(`${value.Key.Inspect()}:${value.Value.Inspect()}`);
        });
        return `{${pairs.join(', ')}}`;
    }
    toJSON() {
        return JSON.stringify(this.toJS());
    }
    toJS() {
        const obj = {};
        this.pairs.forEach((value) => {
            const keyValue = value.Key.Value;
            obj[keyValue] = value.Value.toJS();
        });
        return obj;
    }
    Equals(obj) {
        return obj === this;
    }
}
//# sourceMappingURL=data:application/json;base64,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